import React, { useEffect } from 'react';
import 'moment-timezone';
import moment from 'moment';

function Test() {
  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("device_os", "web");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("user_id", "IZ3XvLPJ40bnQDai1kSdy1hVVpA3" );
    
    var raw = JSON.stringify({
      "schedule_time": 1697190868000,
      "repeating": "false",
      "vehicle_no": "GA07L1729",
      "parking_id": 5693
    });
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    
    fetch("https://apidev.parkquility.com/parking/valet/vehicle/request/schedule", requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log('error', error));
  }, []); 

  return <></>;
}

export default Test;
